import React from "react";

export default function Default(props){
    const styling = {
        backgroundColor : props.backgroundColor,
        boxShadow : props.shadowColor,
        color : props.color
    }

    return props.name === "RESET" ? <div id = "resetBtn" onClick = {props.clicked} style = {styling}>{props.name}</div> :
     <div id = "equalsBtn" onClick = {props.clicked} style = {styling}>{props.name}</div>
}